<template>
	<div class="index-bg">
		<div style="text-align: center;margin-top: 20%;padding: 50px;">
			<div style='padding: 20px;' @click="goPage('/help/index')">
				<img class="opt-img" :src="`${require('@assets/images/dywfl/index-opt1.png')}`" alt="" style="width: 88px;height: 88px;">
				<div>爱心妈妈</div>
			</div>
			<div style='padding: 20px;' @click="goPage('/hope/index')">
				<img class="opt-img" :src="`${require('@assets/images/dywfl/index-opt2.png')}`" alt="" style="width: 88px;height: 88px;">
				<div>微心愿</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: "Rights_Index",
  data: function() {
    return {
    };
  },
  mounted(){
  },
  methods: {
	goPage(url) {
      this.$router.push({ path: url });
    }
  }
};
</script>
<style scoped>
.index-bg{
	width: 100%;
	height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
}

</style>
